module.exports = __webpack_public_path__ + "static/img/guide-34.8fdaee2f.png";